import React from 'react';
import PropTypes from 'prop-types';
import {INSTRUMENT_NAME_MAP} from './utils';

export const INSTRUMENT_HELP_LINKS = Object.freeze({
  bode: {
    overview: 'http://www.ni.com/r/w2csrb',
    connection: 'http://www.ni.com/r/vwva8s',
    configuration: 'http://www.ni.com/r/f52sat',
  },
  scope: {
    overview: 'http://www.ni.com/r/32cpd1',
    connection: 'http://www.ni.com/r/ink0vh',
    configuration: 'http://www.ni.com/r/38ditw',
  },
  iv: {
    overview: 'http://www.ni.com/r/rl0tbq',
    connection: 'http://www.ni.com/r/8ew8la',
    configuration: 'http://www.ni.com/r/wait6d',
  },
  dmm: {
    overview: 'http://www.ni.com/r/mxsxqx',
    connection: 'http://www.ni.com/r/nh2l7u',
    configuration: 'http://www.ni.com/r/2n28i5',
  },
  fgen: {
    overview: 'http://www.ni.com/r/7x4iz7',
    connection: 'http://www.ni.com/r/1v0bkb',
    configuration: 'http://www.ni.com/r/s9alvk',
  },
  vps: {
    overview: 'http://www.ni.com/r/lrhbjs',
    connection: 'http://www.ni.com/r/jcc8wd',
    configuration: 'http://www.ni.com/r/5oe411',
  },
  datalogger: {
    overview: 'http://www.ni.com/r/2qho9j',
    connection: 'http://www.ni.com/r/bgwqbx',
    configuration: 'http://www.ni.com/r/5f487u',
  },
  datagenerator: {
    overview: 'http://www.ni.com/r/v8nnja',
    connection: 'http://www.ni.com/r/l65dip',
    configuration: 'http://www.ni.com/r/fs278v',
  },
  digitalio: {
    overview: 'http://www.ni.com/r/qacudf',
    connection: 'http://www.ni.com/r/l6ecnb',
    configuration: 'http://www.ni.com/r/8rbyv3',
  },
});

const HelpForm = ({instruments, isSimulateMode}) => {
  return (
    <div className="help-menu">
      <div className="title">Help topics:</div>
      {isSimulateMode && (
        <div key="simulate" className="menu-items">
          <div className="title">Simulating Instruments</div>
          <a
            className="menu-item"
            target="_blank"
            rel="noopener noreferrer"
            href={'https://www.ni.com/r/46wojy'}
          >
            Overview
          </a>
        </div>
      )}
      {[...instruments.large, ...instruments.small].map(({name}) => (
        <div key={name} className="menu-items">
          <div className="title">{INSTRUMENT_NAME_MAP[name]}</div>
          <a
            className="menu-item"
            target="_blank"
            rel="noopener noreferrer"
            href={INSTRUMENT_HELP_LINKS[name].overview}
          >
            Overview
          </a>
          <a
            className="menu-item"
            target="_blank"
            rel="noopener noreferrer"
            href={INSTRUMENT_HELP_LINKS[name].connection}
          >
            Connecting signals
          </a>
          <a
            className="menu-item"
            target="_blank"
            rel="noopener noreferrer"
            href={INSTRUMENT_HELP_LINKS[name].configuration}
          >
            Configuration options
          </a>
        </div>
      ))}
    </div>
  );
};

HelpForm.propTypes = {
  instruments: PropTypes.object.isRequired,
  isSimulateMode: PropTypes.bool.isRequired,
};

export default HelpForm;
